<script>
import { BInputGroupAppend } from "bootstrap-vue";

export default {
  extends: BInputGroupAppend
};
</script>